export const GET_WAREHOUSES = 'GET_WAREHOUSES'
export const GET_WAREHOUSES_EXITO = 'GET_WAREHOUSES_EXITO'
export const GET_WAREHOUSES_ERRROR = 'GET_WAREHOUSES_ERROR'
